import React from "react";
import { TextField } from "@mui/material";
import { BaseLabel, colors, BaseBadge } from "components";
import { useReadOnly } from "../../contexts/ReadOnlyContext";
import { Container, LabelContainer, Label, LabelRequired } from "./styles";

export interface IBaseInput {
  id?: string;
  ref?: any;
  defaultValue?: string;
  name: string;
  label: string;
  marginBottom?: string;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  helperText?: React.ReactNode;
  error?: boolean;
  setError?: React.Dispatch<React.SetStateAction<boolean>>;
  value: string;
  height?: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  onChange: (e: string) => unknown;
  autofocus?: boolean;
  autoComplete?: string;
  inputRef?: React.Ref<HTMLInputElement>;
}

export function GeneralInput({
  id,
  label,
  name,
  helperText,
  error = false,
  setError,
  value,
  defaultValue,
  maxLength,
  height = "48px",
  disabled = false,
  required = false,
  onChange,
  ref,
  autofocus = false,
  autoComplete = "on",
  inputRef,
}: IBaseInput) {
  const ro = useReadOnly();
  const isDisabled = ro || disabled;

  const handleOnFocus = () => {
    if (setError) setError(false);
  };

  return (
    <Container id={id} height={height}>
      <LabelContainer>
        <Label>
          <BaseLabel
            marginBottom="6px"
            marginLeft="0px"
            fontSize="12px"
            color={colors.neutral_gray_40}
          >
            {label}
          </BaseLabel>
        </Label>
        <LabelRequired>{required ? <BaseBadge color="warning" /> : null}</LabelRequired>
      </LabelContainer>

      <TextField
        ref={ref}
        inputRef={inputRef}
        name={name}
        fullWidth
        helperText={helperText}
        defaultValue={defaultValue}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-cy={`${id}_input`}
        variant="outlined"
        className="input_mui"
        error={error}
        disabled={isDisabled}
        inputProps={{ maxLength: maxLength, autoComplete: autoComplete }}
        onFocus={handleOnFocus}
        autoFocus={autofocus}
        autoComplete={autoComplete}
      />
    </Container>
  );
}

export default GeneralInput;
